import CONFIG from "./constants/config";

const GA_MEASUREMENT_ID = CONFIG.GA_MEASUREMENT_ID;
const GA_SCRIPT_URL = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;

let isGaInitialized = false;
let isGaScriptInjected = false;
let interactionListenersBound = false;

function initGaStub() {
  if (typeof window === "undefined" || !GA_MEASUREMENT_ID || isGaInitialized) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };

  // Queue GA bootstrap commands; they are picked up once gtag.js loads.
  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });
  isGaInitialized = true;
}

function injectGaScript() {
  if (typeof window === "undefined" || !GA_MEASUREMENT_ID || isGaScriptInjected) return;
  isGaScriptInjected = true;
  const script = document.createElement("script");
  script.src = GA_SCRIPT_URL;
  script.async = true;
  document.head.appendChild(script);
}

function bindInteractionListeners() {
  if (typeof window === "undefined" || interactionListenersBound) return;
  interactionListenersBound = true;
  const events = ["scroll", "click", "touchstart", "keydown", "pointerdown"];
  const onFirstInteraction = () => injectGaScript();
  events.forEach((eventName) => {
    window.addEventListener(eventName, onFirstInteraction, { once: true, passive: true });
  });
}

/**
 * Send a page view to Google Analytics 4.
 * Use this for SPA route changes since full page loads are not triggered.
 */
export const trackPageView = (path, title) => {
  initGaStub();
  bindInteractionListeners();
  if (typeof window !== "undefined" && window.gtag && GA_MEASUREMENT_ID) {
    window.gtag("config", GA_MEASUREMENT_ID, {
      page_path: path,
      page_title: title || document.title,
    });
  }
};

/**
 * Send a custom event to Google Analytics 4.
 * @param {string} eventName - GA4 event name (e.g. 'click_play_store')
 * @param {Object} [params] - Optional event parameters (location, platform, slug, etc.)
 *
 * NOTE: For parameters to appear in GA4 reports, create custom dimensions in:
 * GA4 Admin > Data display > Custom definitions > Create custom dimension
 * - Dimension name: e.g. "Location"
 * - Scope: Event
 * - Event parameter: e.g. "location"
 */
export const trackEvent = (eventName, params = {}) => {
  initGaStub();
  // Events are user-driven by definition; load GA library only when needed.
  injectGaScript();
  if (typeof window !== "undefined" && window.gtag && GA_MEASUREMENT_ID) {
    // Filter out undefined/null values - GA4 may not accept them
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v != null && v !== "")
    );
    window.gtag("event", eventName, {
      ...cleanParams,
      send_to: GA_MEASUREMENT_ID,
    });
  }
};
